import { render, staticRenderFns } from "./Confettis.vue?vue&type=template&id=15a5c7a2&scoped=true"
import script from "./Confettis.vue?vue&type=script&lang=js"
export * from "./Confettis.vue?vue&type=script&lang=js"
import style0 from "./Confettis.vue?vue&type=style&index=0&id=15a5c7a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a5c7a2",
  null
  
)

export default component.exports